module.exports = __webpack_public_path__ + "img/8.b697d45f.png";